"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAlertText = exports.StyledAlert = exports.MID_SIZE_BREAKPOINT = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
var MID_SIZE_BREAKPOINT = exports.MID_SIZE_BREAKPOINT = '500px';
var theme = {
  "default": {
    background: '#575D67',
    color: '#ffffff',
    icon: '#ffffff'
  },
  info: {
    background: '#DFE3EC',
    color: '#33373D',
    icon: '#767676'
  },
  warning: {
    background: '#FFEA7F',
    color: '#33373D',
    icon: '#767676'
  },
  alert: {
    background: '#DE2F1B',
    color: '#ffffff',
    icon: '#ffffff'
  },
  success: {
    background: '#32A976',
    color: '#ffffff',
    icon: '#ffffff'
  },
  dark: {
    background: '#F9F9FB',
    color: '#6E7582',
    icon: '#767676'
  }
};
var getColor = function getColor(variant, prop) {
  return theme[variant][prop];
};
var StyledAlertText = exports.StyledAlertText = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  white-space: nowrap;\n"])));
var StyledAlert = exports.StyledAlert = _styledComponents["default"].div(function (_ref) {
  var color = _ref.color;
  return "\n  display: inline-flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  height: auto;\n  padding: 4px 8px;\n  border-radius: 4px;\n  background: ".concat(getColor(color, 'background'), ";\n  color: ").concat(getColor(color, 'color'), ";\n  box-sizing: border-box;\n  border-radius: 4px;\n\n  @media (max-width: ").concat(MID_SIZE_BREAKPOINT, ") {\n    justify-content: inherit;\n  }\n\n  svg {\n    font-size: 16px;\n    line-height: 16px;\n    margin-right: 8px;\n    color: ").concat(getColor(color, 'icon'), ";\n  }\n\n  .text {\n    font-weight: 400;\n    font-style: normal;\n    font-size:  16px;\n    line-height: 24px;\n    min-width: 0;\n    overflow-wrap: break-word;\n\n    @media (max-width: ").concat(MID_SIZE_BREAKPOINT, ") {\n      display: none;\n    }\n  }\n\n  .duration {\n    font-weight: 600;\n    font-style: normal;\n    font-size: 16px;\n    line-height: 24px;\n  }\n");
});